import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AccountService } from 'src/app/core/service/account.service';
import { ToastrService } from 'ngx-toastr';
import { EmailValidationService } from 'src/app/core/service/email-validation.service';

@Component({
  selector: 'app-price-confirmation',
  templateUrl: './price-confirmation.component.html',
  styleUrls: ['./price-confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PriceConfirmationComponent implements OnInit {
  @Input() offerData: any;
  @Input() selectedOption: string | undefined;
  @Input() rawOfferObj: any;
  @Input() oppId: any;
  @Input() optionIndex: number | undefined;
  @Input() isLoanProductMode: boolean = false;

  favIcon: any;
  logoUrl: any;
  offerMaxLimit: number | undefined;
  loading = false;
  offerTerm: number | undefined;
  offerFactor: number | undefined;
  estAPR: number | undefined;
  offerDailyPayment: any;
  collectionSchedule: string | undefined;
  termsChangedError = false;
  termsChangedErrorMsg = '';
  isEmailValid: boolean = false;
  emailValidationWarning: string = '';
  state: string | undefined;

  constructor(
    public modalRef1: BsModalRef,
    public modalRef2: BsModalRef,
    private modalService: BsModalService,
    private accountService: AccountService,
    private toastr: ToastrService,
    private emailValidationService: EmailValidationService
  ) { }



  ngAfterViewInit() {
    this.favIcon = this.offerData.faviconUrl;
    this.logoUrl = this.offerData.logoUrlDark;
    this.offerMaxLimit = this.offerData.limit;
    this.offerTerm = this.offerData.term;
    this.offerFactor = this.offerData.factor;
    this.estAPR = this.offerData.estAPR;
    this.offerDailyPayment = this.offerData.dailyPayment;
    this.collectionSchedule = this.offerData.collectionSchedule;
    this.state = this.state;
    console.log("State in Price Confirmation: " + this.state);
  }

  /**
  * Checks if Estimated APR should be shown based on state.
  * Consistent with pricing-cal.component.ts: only for NY/CA AND non-loan (MCard) mode.
  * CreditFacility (loan mode) does not show estAPR — only the factor rate shows as "Repayment per $1".
  */
  shouldShowEstAPR(): boolean {
    const isNYorCA = /^(ny|new york|ca|california)$/i.test(this.state?.trim() || '');
    return isNYorCA && !this.isLoanProductMode;
  }


  reloadPage() {
    window.location.reload();
  }

  @Output() loadingChange = new EventEmitter<boolean>();
  openStatusModal(template: TemplateRef<any>) {
    const offerId = this.offerData.offerId || '';
    this.loading = true;
    this.loadingChange.emit(this.loading);
    this.termsChangedError = false;
    this.termsChangedErrorMsg = '';
    // if (this.loading && this.modalRef1) {
    //   this.modalService.config.ignoreBackdropClick = true;
    //   // console.log("i am here Loading: " + this.loading);
    // }
    this.accountService.acceptOffer(this.oppId, offerId, { ...this.rawOfferObj, merchantEmail: this.merchantEmail }).subscribe(
      (response) => {
        this.modalRef1.hide();
        this.toastr.success('Offer accepted successfully!');
        this.modalRef2 = this.modalService.show(template, { class: 'modal-lg statusModal', ignoreBackdropClick: false });
        this.loading = false;
        this.loadingChange.emit(this.loading);
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      },
      (error) => {
        this.loading = false;
        this.loadingChange.emit(this.loading);
        this.termsChangedError = error.error.includes('terms have changed');
        const isGenericError = error.error.includes('GENERIC_ERROR');
        // this.modalService.config.ignoreBackdropClick = false;
        if (!this.termsChangedError) {
          this.toastr.error(`${isGenericError ? 'Unexpected error occurred, try again later' : error.error}. Please contact Revenued Support if the issue persists.`);
        } else {
          this.termsChangedErrorMsg = `${error.error}.`;
        }
        console.error('Error accepting offer:', error);
      }
    );
  }

  // Merchant Email Confirmation
  merchantEmail: string = '';
  tempEmail: string = this.merchantEmail;
  isEditing: boolean = false;

  // Email validation methods
  isEmailFormatValid(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  onEmailInputChange() {
    // Clear validation warning when user starts typing
    if (this.emailValidationWarning) {
      this.emailValidationWarning = '';
    }
  }

  saveEmail() {
    if (!this.tempEmail) {
      this.toastr.error('Please enter an email address');
      this.isEmailValid = false;
      this.emailValidationWarning = '';
      return;
    }

    // Check email format before making API call
    if (!this.isEmailFormatValid(this.tempEmail)) {
      this.toastr.error('Please enter a valid email address');
      this.isEmailValid = false;
      this.emailValidationWarning = 'Please enter a valid email format.';
      return;
    }

    this.loading = true;
    this.loadingChange.emit(this.loading);
    this.emailValidationWarning = '';

    this.emailValidationService.validateEmail(this.tempEmail).subscribe(
      (result) => {
        this.loading = false;
        this.loadingChange.emit(this.loading);
        this.merchantEmail = this.tempEmail;
        this.isEditing = false;
        this.isEmailValid = true;
        this.emailValidationWarning = '';
        if (!result.isValid) {
          // this.toastr.error(result.error || 'Invalid email address');
          this.isEmailValid = false;
          this.emailValidationWarning = 'Email is invalid, please enter a valid email to continue.';
        }

        if (result.isDisposable) {
          // this.toastr.warning('Disposable email addresses are not allowed');
          this.isEmailValid = true;
          this.emailValidationWarning = 'Email is invalid, please enter a valid email to continue.';
        }
        // this.toastr.success('Email saved successfully');
      },
      (error) => {
        this.loading = false;
        this.loadingChange.emit(this.loading);
        this.merchantEmail = this.tempEmail;
        this.isEmailValid = true;
        this.isEditing = false;
        this.emailValidationWarning = '';
        // Even on error, consider email as valid
        console.error('Email validation error:', error);
      }
    );
  }

  cancelEdit() {
    this.tempEmail = this.merchantEmail;
    this.isEditing = false;
    this.emailValidationWarning = '';
  }

  ngOnInit() {
    console.log("Option Index: " + this.optionIndex);
    (window as any).priceConfirmation = this;
    this.isEditing = true;
    this.merchantEmail = '';
    this.tempEmail = this.merchantEmail;
    this.isEmailValid = false;
    this.emailValidationWarning = '';
  }

  // Style 2
  confirmEmail = 'yes';
  email: string = '';


}
